import getSymbolFromCurrency from 'currency-symbol-map';
import { KIOSK_ID_LIST } from '../constants';

export const printCurrencySymbol = (restaurantDetails = {}) => {
    let definedSymbol = restaurantDetails?.hotel_config?.currency_symbol;
    if (definedSymbol) {
        return definedSymbol;
    }
    const currencyCode = restaurantDetails.country?.currency_code?.toUpperCase();
    if (
        currencyCode === 'AED' ||
        currencyCode === 'FJD' ||
        currencyCode === 'PHL' ||
        currencyCode === 'SAR' ||
        currencyCode === 'OMR'
    ) {
        return currencyCode;
    }
    return getSymbolFromCurrency(currencyCode);
};

const getCircularReplacer = () => {
    const seen = new WeakSet();
    return (key, value) => {
        if (typeof value === 'object' && value !== null) {
            if (seen.has(value)) {
                return;
            }
            seen.add(value);
        }
        return value;
    };
};

export const getMasterMenuList = () => {
    const menuList = localStorage.getItem('menuMaster');
    if (menuList) {
        return JSON.parse(menuList);
    }
};

export const setMasterMenuList = (masterMenu) => {
    if (masterMenu) {
        localStorage.setItem('menuMaster', JSON.stringify(masterMenu));
    }
};

export const getMasterMenuOnlyList = () => {
    const menuList = localStorage.getItem('menuOnlyMaster');
    if (menuList) {
        return JSON.parse(menuList);
    }
};

export const setMasterMenuOnlyList = (masterMenu) => {
    if (masterMenu) {
        localStorage.setItem('menuOnlyMaster', JSON.stringify(masterMenu));
    }
};

export const getLocalCartItems = () => {
    try {
        const cartItems = JSON.parse(localStorage.getItem('cartItems'));
        return cartItems ? cartItems : [];
    } catch (e) {
        return [];
    }
};

export const makeLocalCartItemsEmpty = () => {
    localStorage.setItem('cartItems', JSON.stringify([]));
};

export const addLocalCartItem = (menuItem) => {
    let items = getLocalCartItems();
    items.push(menuItem);
    items = JSON.stringify(items, getCircularReplacer());
    localStorage.setItem('cartItems', items);
};

export const updateLocalCartItem = (menuItem) => {
    let items = getLocalCartItems();
    items = items.map((item) => {
        if (item.cartItemId === menuItem.cartItemId) {
            item = menuItem;
        }
        return item;
    });
    items = JSON.stringify(items, getCircularReplacer());
    localStorage.setItem('cartItems', items);
};

export const removeLocalCartItem = (cartItemId) => {
    const items = getLocalCartItems();
    const newItems = items.filter((item) => item.cartItemId !== cartItemId);
    localStorage.setItem('cartItems', JSON.stringify(newItems));
};

// Add timestamp to the current item to keep track when was the item added to cart
export const generateCartItem = (item) => {
    const cartItem = JSON.parse(JSON.stringify(item, getCircularReplacer()));
    delete cartItem.cartItems;
    cartItem.cart_timestamp = new Date().toISOString();
    // contains no. of cart item
    cartItem.cart_item_count = 1;
    cartItem.cartItemId = Math.random();
    return cartItem;
};

// Increment/decrement localCartItem
export const updateCartItem = (cartItem) => {
    const items = getLocalCartItems();
    const updatedCartItems = items.map((item) => {
        if (item.cartItemId === cartItem.cartItemId) {
            item = cartItem;
        }
        return item;
    });
    updateAllCartItem(updatedCartItems);
};

// update all  local cart items at once
export const updateAllCartItem = (updatedCartItems) => {
    updatedCartItems = JSON.stringify(updatedCartItems, getCircularReplacer());
    localStorage.setItem('cartItems', updatedCartItems);
};

export const clearCart = () => {
    try {
        localStorage.removeItem('cartItems');
    } catch (error) {}
};

export const setDataIntoLS = (key, data) => {
    try {
        localStorage.setItem(key, data);
    } catch (e) {}
};

export const getDataFromLS = (key) => {
    try {
        const data = localStorage.getItem(key);
        if (data) {
            return JSON.parse(data);
        }
        return null;
    } catch (e) {
        return null;
    }
};

export const removeFromStorage = (key) => {
    try {
        localStorage.removeItem(key);
        localStorage.removeItem(key);
    } catch (error) {}
};
export const getFormData = (object) => {
    let formd = Object.keys(object).reduce((formData, key) => {
        formData.append(key, object[key]);
        return formData;
    }, new FormData());
    return formd;
};

export const pineLabsPaymentInitate = (
    OrderId,
    id,
    amount,
    paymentMode,
    cb,
    KIOSKID
) => {
    if ('WebSocket' in window) {
        let ws = new WebSocket('ws://localhost:2012/');
        ws.onopen = function () {
            // Web Socket is connected, send data using send()
            let no = paymentMode === 'card' ? 4001 : 5120;
            // let no = paymentMode === 'upi' ? 5102 : 4001;
            // if (paymentMode === 'upi') {
            //     if (KIOSK_ID_LIST?.PVRMOI?.includes(KIOSKID)) {
            //         no = 5120;
            //     } else {
            //         no = ;
            //     }
            // }
            ws.send(`${no}, TX${id}, ${amount}`);
            //alert("Message is sent...");
        };
        ws.onmessage = function (evt) {
            const paymentResponse = evt.data || [];
            cb(paymentResponse, OrderId, id);
        };

        ws.onclose = function (e) {
            console.log(
                'Socket is closed. Reconnect will be attempted in 1 second.',
                e.reason
            );
            setTimeout(function () {
                pineLabsPaymentInitate(
                    OrderId,
                    id,
                    amount,
                    paymentMode,
                    cb,
                    KIOSKID
                );
            }, 1000);
        };

        ws.onerror = function (err) {
            console.error(
                'Socket encountered error: ',
                err.message,
                'Closing socket'
            );
            ws.close();
        };
        window.onbeforeunload = function (event) {};
    } else {
        // The browser doesn't support WebSocket
        alert('WebSocket NOT supported by your Browser!');
    }
};

export const getKIOSKName = (id) => {
    if (KIOSK_ID_LIST.PVRAmbience.includes(id)) {
        return 'PVRAmbience';
    } else if (KIOSK_ID_LIST.PVRMOI.includes(id)) {
        return 'PVRMOI';
    } else if (KIOSK_ID_LIST.PVRCCG.includes(id)) {
        return 'PVRCCG';
    } else if (KIOSK_ID_LIST.PVRMEGAMALLGURGAON.includes(id)) {
        return 'PVRMEGAMALLGURGAON';
    } else if (KIOSK_ID_LIST.INOXMUMBAI.includes(id)) {
        return 'INOXMUMBAI';
    } else if (KIOSK_ID_LIST.CINEPOLIS.includes(id)) {
        return 'CINEPOLIS';
    } else if (KIOSK_ID_LIST.NYRESTAURANTS.includes(id)) {
        return 'NYRESTAURANTS';
    } else {
        return '';
    }
};

export const getTermsAndPolicyData = (kioskID) => {
    const pvrName = getKIOSKName(kioskID);
    // if (pvrName) {
    //     return termsAndConditions[pvrName];
    // }
    return {};
};

export const isEmpty = (value) => {
    if (value === null || value === undefined) {
        return true;
    }

    if (typeof value === 'number') {
        return false;
    }

    if (typeof value === 'string' || Array.isArray(value)) {
        return value.length === 0;
    }

    if (typeof value === 'object') {
        return Object.keys(value).length === 0;
    }

    return true;
};

export const populateCartFields = (items, localCart) => {
    const populatedItem = items?.map((item) => {
        // updating total selected count
        updateAddonCount(item);

        // new cartItems property would be added in case cart item updated
        item['cartItems'] =
            localCart?.filter((cart) => cart?.id === item.id) || [];
        return item;
    });
    return populatedItem;
};
// add count field to addon
const updateAddonCount = (item) => {
    // Add addon and subAddon count = 0 for all available addon inside menuItem
    const updateCount = (addOns) => {
        for (const addOn of addOns) {
            addOn.count = 0;
        }
    };
    // adding sub-addon category and without sub-addon items in a single place
    item.sub_addons?.forEach((subAdd) => {
        updateCount(subAdd.addons);
    });
};

export const getCartTotal = (localCartData = []) => {
    let total = 0;
    localCartData.forEach((item) => {
        let itemTotal =
            item.price_with_tax_included * item.cart_item_count ?? 1;
        item.sub_addons?.forEach((subAddon) => {
            if (subAddon.enabled) {
                subAddon.addons?.forEach((addon) => {
                    if (
                        (addon.checkedItem || addon.isChecked) &&
                        addon.enabled
                    ) {
                        itemTotal +=
                            addon.price_with_tax_included * addon.count ?? 0;
                    }
                });
            }
        });
        total += itemTotal;
    });
    return total;
};

export const getCount = (item) => {
    let total = 0;
    total = item.cartItems?.reduce(
        (acc, subItem) => acc + subItem.cart_item_count ?? 0,
        0
    );
    return total;
};

export const getAddonsId = (itemAddon) => {
    let addonsIdList = [];
    itemAddon.sub_addons?.forEach((subaddon) => {
        subaddon.addons?.forEach((addon) => {
            if (
                (addon.checkedItem || addon.isChecked) &&
                addon.count > 0 &&
                addon.enabled
            ) {
                addonsIdList.push(addon.id);
            }
        });
    });
    return addonsIdList;
};

export const isArrEqual = (arr1, arr2) => {
    if (arr1.length !== arr2.length) return false;
    if (arr1.join() !== arr2.join()) return false;

    // Comparing each element of array
    for (var i = 0; i < arr1.length; i++) if (arr1[i] !== arr2[i]) return false;
    return true;
};

export const getApiFormattedCartItems = () => {
    const cartItems = getLocalCartItems();

    const formattedItems = cartItems.map((cartItem) => {
        const { id, cart_item_count, sub_addons } = cartItem;

        const formattedItem = {
            id: id,
            quantity: cart_item_count,
            addons: [],
        };

        const formatSubAddons = (addons) => {
            addons.forEach((addon) => {
                if (addon.count > 0) {
                    formattedItem.addons.push({
                        id: addon.id,
                        quantity: addon.count,
                    });
                }
            });
        };

        sub_addons.forEach((subAdd) => {
            formatSubAddons(subAdd.addons);
        });
        return formattedItem;
    });
    return formattedItems;
};

export const dataURItoBlob = (dataURI) => {
  // convert base64/URLEncoded data component to raw binary data held in a string
  var byteString;
  if (dataURI.split(",")[0].indexOf("base64") >= 0)
    byteString = atob(dataURI.split(",")[1]);
  else byteString = unescape(dataURI.split(",")[1]);

  // separate out the mime component
  var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];

  // write the bytes of the string to a typed array
  var ia = new Uint8Array(byteString.length);
  for (var i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  return new Blob([ia], { type: mimeString });
};


export const renderPrice = (price = 0, restaurantDetails = {}) => {
    return price.toLocaleString('en-US', {
        minimumFractionDigits:
            restaurantDetails?.hotel_config?.amount_precise_after_decimal === 0
                ? 0
                : restaurantDetails?.hotel_config?.amount_precise_after_decimal || 2,
        maximumFractionDigits:
            restaurantDetails?.hotel_config?.amount_precise_after_decimal === 0
                ? 0
                : restaurantDetails?.hotel_config?.amount_precise_after_decimal || 2,
    });
};

export  const convertTimeUTC= (userDate) =>{
    let now,nowUtc, day, month, year, minutes, hours;
    if(userDate && userDate != " "){
      now = new Date(userDate);
      nowUtc = new Date( now.getTime() + (now.getTimezoneOffset() * 60000));
      nowUtc = new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), now.getUTCHours(), now.getUTCMinutes(), now.getUTCSeconds());
      day = '' + (nowUtc.getDate());
      month = '' + (nowUtc.getMonth() + 1);
      year = nowUtc.getFullYear();
      minutes = '' + nowUtc.getMinutes();
      hours = '' + nowUtc.getHours();
      if (month.length < 2) month = 0 + month;
      if (day.length < 2) day = 0 + day;
      if (minutes.length < 2) minutes = 0 + minutes;
      if (hours.length < 2) hours = 0 + hours;
      console.log(`${year}-${month}-${day} ${hours}:${minutes}:00`);
      return `${year}-${month}-${day} ${hours}:${minutes}:00`;
    }else{
      console.log('Invalid date and time');
      return false;
    }
  }
